var quiz = {
    "products": [
      {
            "handle": "epic-lux-lab-edition-anc-over-ear-headphones-black",
            "product_id": 6932095107144,
            "product_title": "Epic Lux ANC Lab Edition",
            "ans": [
                [
                    5,
                    0,
                    15,
                    10,
                    0
                ],
                [
                    15,
                    5,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    0
                ],
                [
                    0,
                    5,
                    15
                ],
                [
                    10
                ]
            ]
        },  
      {
            "handle": "go-lux-anc-wireless-headphones-graphite",
            "product_id": 6931856293960,
            "product_title": "Go Lux ANC",
            "ans": [
                [
                    5,
                    0,
                    15,
                    10,
                    0
                ],
                [
                    5,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    0
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    10
                ]
            ]
        },
        {
            "handle": "epic-sport-anc-3-true-wireless-earbuds-black",
            "product_id": 6899969949768,
            "product_title": "Epic Sport ANC 3",
            "ans": [
                [
                    15,
                    0,
                    15,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    5,
                    10,
                    15
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "epic-air-anc-true-wireless-earbuds-gen-2",
            "product_id": 6893539721288,
            "product_title": "Epic Air ANC Gen 2",
            "ans": [
                [
                    0,
                    0,
                    15,
                    15,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    5,
                    10,
                    15
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "fit-sport-3-wireless-fitness-earbuds-black",
            "product_id": 6893540638792,
            "product_title": "Fit Sport 3",
            "ans": [
                [
                    15,
                    0,
                    5,
                    5,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    0,
                    15,
                    0
                ],
                [
                    5,
                    15,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "go-pop-anc-true-wireless-earbuds-black",
            "product_id": 6906282180680,
            "product_title": "Go POP ANC",
            "ans": [
                [
                    10,
                    0,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "go-pop-plus-true-wireless-earbuds-black",
            "product_id": 6894711930952,
            "product_title": "Go POP +",
            "ans": [
                [
                    10,
                    0,
                    10,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "go-sport-plus-earbuds-graphite",
            "product_id": 6894485569608,
            "product_title": "Go Sport +",
            "ans": [
                [
                    15,
                    0,
                    15,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    0
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "go-tones-plus-true-wireless-earbuds-7572w",
            "product_id": 6893536477256,
            "product_title": "Go Tones +",
            "ans": [
                [
                    10,
                    0,
                    10,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "go-work-pop-wireless-on-ear-headset-black",
            "product_id": 6893539754056,
            "product_title": "Go Work POP",
            "ans": [
                [
                    0,
                    0,
                    0,
                    15,
                    0
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    10
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "work-buds-in-ear-headset-black",
            "product_id": 6893537460296,
            "product_title": "Work Buds",
            "ans": [
                [
                    0,
                    0,
                    0,
                    15,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    5,
                    10
                ],
                [
                    5,
                    15,
                    15
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuds-work-wireless-over-ear-headset-black",
            "product_id": 6893538541640,
            "product_title": "JBuds Work Headset",
            "ans": [
                [
                    0,
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    0,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    10
                ],
                [
                    5,
                    15,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "epic-work-anc-wireless-on-ear-headset-black",
            "product_id": 6820396138568,
            "product_title": "Epic Work Headset",
            "ans": [
                [
                    0,
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    0,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    10
                ],
                [
                    5,
                    10,
                    15
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "jbuddies-learn-on-ear-kids-headphone-gray",
            "product_id": 6911051530312,
            "product_title": "JBuddies Learn",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    0,
                    10,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    15
                ],
                [
                    5,
                    5,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuddies-play-gaming-kids-headset-black",
            "product_id": 6911059591240,
            "product_title": "JBuddies Play",
            "ans": [
                [
                    0,
                    15,
                    0,
                    0,
                    15
                ],
                [
                    0,
                    10,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    0
                ],
                [
                    5,
                    5,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuddies-pro-wireless-over-ear-kids-headphones-blue",
            "product_id": 6893539852360,
            "product_title": "JBuddies Pro Wireless",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    10,
                    0,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    5,
                    10,
                    10
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuddies-studio-wireless-kids-headphones-graphite-blue",
            "product_id": 6893536444488,
            "product_title": "JBuddies Studio Wireless",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    10
                ],
                [
                    5,
                    15,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuddies-pop-wireless-kids-headphones-teal",
            "product_id": 6918917652552,
            "product_title": "JBuddies POP Wireless",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    10
                ],
                [
                    5,
                    15,
                    5
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "jbuddies-anc-kids-headphones-blue-red",
            "product_id": 6918934757448,
            "product_title": "JBuddies ANC Wireless",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    5
                ],
                [
                    5,
                    10,
                    15
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "jbuddies-studio-on-ear-kids-wired-headphones-graphite-blue",
            "product_id": 6893538345032,
            "product_title": "JBuddies Studio Wired",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    20
                ],
                [
                    5,
                    5,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuds-sport-anc-4-true-wireless-earbuds-graphite",
            "product_id": 6893536149576,
            "product_title": "JBuds Sport ANC 4",
            "ans": [
                [
                    15,
                    0,
                    10,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    0,
                    0
                ],
                [
                    5,
                    15,
                    5
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "jbuds-open-sport-earbuds-black",
            "product_id": 6904026923080,
            "product_title": "JBudes Open Sport",
            "ans": [
                [
                    15,
                    0,
                    5,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    15
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    5,
                    15,
                    15
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "flex-open-earbuds-black",
            "product_id": 6893541130312,
            "product_title": "Flex Open",
            "ans": [
                [
                    5,
                    0,
                    10,
                    15,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    15
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "jbuds-pro-wireless-signature-earbuds-black",
            "product_id": 6893538279496,
            "product_title": "JBuds Pro Wireless",
            "ans": [
                [
                    5,
                    0,
                    5,
                    5,
                    0
                ],
                [
                    0,
                    0,
                    10,
                    0
                ],
                [
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "rewind-2-wireless-retro-headphones-black",
            "product_id": 6899221233736,
            "product_title": "Rewind 2",
            "ans": [
                [
                    0,
                    0,
                    10,
                    10,
                    10
                ],
                [
                    0,
                    10,
                    0,
                    5
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "studio-anc-on-ear-wireless-headphones-black",
            "product_id": 6893538869320,
            "product_title": "Studio ANC",
            "ans": [
                [
                    0,
                    0,
                    10,
                    15,
                    0
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    5,
                    15,
                    10
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jlab-studio-wireless-on-ear-headphones-black",
            "product_id": 6893538705480,
            "product_title": "Studio Wireless",
            "ans": [
                [
                    0,
                    0,
                    10,
                    10,
                    0
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    5,
                    15,
                    10
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jlab-studio-on-ear-wired-headphones-black",
            "product_id": 6893537361992,
            "product_title": "Studio Wired",
            "ans": [
                [
                    0,
                    0,
                    10,
                    15,
                    0
                ],
                [
                    0,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    20
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "studio-pro-over-ear-headphones-black",
            "product_id": 6893540442184,
            "product_title": "Studio Pro Wired",
            "ans": [
                [
                    0,
                    0,
                    10,
                    15,
                    0
                ],
                [
                    15,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    20
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "studio-pro-wireless-over-ear-headphones-black",
            "product_id": 6893538607176,
            "product_title": "Studio Pro Wireless",
            "ans": [
                [
                    0,
                    0,
                    15,
                    15,
                    0
                ],
                [
                    15,
                    0,
                    0,
                    0
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    10,
                    15,
                    0
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "jbuds-mini-true-wireless-earbuds-black",
            "product_id": 6893521600584,
            "product_title": "JBuds Mini",
            "ans": [
                [
                    5,
                    0,
                    10,
                    5,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    0
                ],
                [
                    10,
                    15,
                    10
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "nightfall-gaming-headset-black",
            "product_id": 6893538639944,
            "product_title": "Nightfall",
            "ans": [
                [
                    0,
                    15,
                    0,
                    0,
                    0
                ],
                [
                    15,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    15
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "nightfall-wireless-gaming-headset-black",
            "product_id": 6895468576840,
            "product_title": "Nightfall Wireless",
            "ans": [
                [
                    0,
                    15,
                    0,
                    0,
                    0
                ],
                [
                    15,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    10
                ],
                [
                    15,
                    10,
                    0
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "epic-lab-edition-earbuds-black",
            "product_id": 6893536247880,
            "product_title": "Epic Lab Edition",
            "ans": [
                [
                    5,
                    0,
                    15,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    5,
                    10,
                    15
                ],
                [
                    5
                ]
            ]
        },
        {
            "handle": "go-work-wireless-on-ear-headset-gen-2-black",
            "product_id": 6893538967624,
            "product_title": "Go Work Gen 2",
            "ans": [
                [
                    0,
                    5,
                    0,
                    15,
                    0
                ],
                [
                    5,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    0
                ],
                [
                    15,
                    10,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuds-pro-usb-c-earbuds-black",
            "product_id": 6893540147272,
            "product_title": "JBuds Pro USBC",
            "ans": [
                [
                    5,
                    5,
                    5,
                    5,
                    5
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    0,
                    0,
                    20
                ],
                [
                    15,
                    5,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuddies-folding-gen-2-kids-headphones-blue-gray",
            "product_id": 6893536510024,
            "product_title": "JBuddies Folding Gen 2",
            "ans": [
                [
                    0,
                    0,
                    0,
                    0,
                    15
                ],
                [
                    5,
                    15,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    15
                ],
                [
                    10,
                    10,
                    10
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuds-anc-true-wireless-earbuds-gen-3-black",
            "product_id": 6893539819592,
            "product_title": "JBuds ANC 3",
            "ans": [
                [
                    10,
                    0,
                    15,
                    10,
                    0
                ],
                [
                    0,
                    0,
                    15,
                    0
                ],
                [
                    15,
                    5,
                    0
                ],
                [
                    10,
                    15,
                    5
                ],
                [
                    0
                ]
            ]
        },
        {
            "handle": "jbuds-lux-anc-headphones-graphite",
            "product_id": 6893537099848,
            "product_title": "JBuds Lux ANC",
            "ans": [
                [
                    10,
                    5,
                    15,
                    10,
                    0
                ],
                [
                    15,
                    5,
                    0,
                    0
                ],
                [
                    0,
                    15,
                    10
                ],
                [
                    10,
                    15,
                    10
                ],
                [
                    5
                ]
            ]
        }
    ]
};